
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12775',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12775",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.488",
  "data-fetching-client": "static-1.9808",
  "foundations-components": "static-1.8227",
  "foundations-components-legacy": "static-1.1252",
  "foundations-theming": "static-1.4585",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.84",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8170",
  "hub-http-shared-msw-handlers": "static-1.10322",
  "hubspot-dlb": "static-2.1854",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11618",
  "I18n": "static-7.1643",
  "jasmine-runner": "static-1.6605",
  "marketplace-storefront-base": "static-1.12838",
  "quartz": "static-1.7225",
  "react-dlb": "static-1.82",
  "react-rhumb": "static-1.16837",
  "reactive-variable-buffer-atom": "static-1.3004",
  "reporting-testing-lib": "static-1.10066",
  "reselect": "static-3.7",
  "settings-ui-lib": "static-1.12670",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7408",
  "ui-addon-i18n": "static-1.11297",
  "ui-addon-react-router-dom": "static-1.9683",
  "unified-auth": "static-1.670",
  "unified-auth-core-lib": "static-1.952",
  "usage-tracker": "static-1.7500",
  "usage-tracker-core": "static-1.7350",
  "customer-data-property-utils": "static-1.8243",
  "hub-http": "static-1.6369",
  "integrations-lib": "static-1.16609",
  "marketplace-ui-common": "static-1.20244",
  "property-management-iframe": "static-1.13651",
  "quartz-config": "static-1.1003",
  "quartz-core": "static-1.6444",
  "quartz-routing": "static-1.655",
  "quick-fetch": "static-1.4027",
  "react": "static-7.188",
  "rpc-client-utils": "static-1.4808",
  "ts-schema": "static-1.4192",
  "ui-universal-auth": "static-1.9156",
  "UIComponents": "static-3.8564",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3511",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3502",
  "quartz-webpack": "static-1.3449",
  "bend-plugin-quartz-routing": "static-1.303",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4496",
  "floating-ui": "static-1.59",
  "foundations-assets": "static-1.5022",
  "foundations-theming-specialty": "static-1.2301",
  "framer-motion": "static-1.74",
  "hs-story-utils": "static-1.9571",
  "react-aria": "static-1.68",
  "react-create-root-preference": "static-1.41",
  "react-select-plus": "static-1.107",
  "react-utils": "static-2.5451",
  "react-virtualized": "static-2.101",
  "StyleGuideUI": "static-3.490",
  "tanstack-table": "static-1.57",
  "trellis-assets": "static-1.2243",
  "ui-fonts": "static-1.880",
  "ui-images": "static-2.1194",
  "bend-plugin-foundations-theming": "static-1.3068",
  "foundations-theming-base": "static-1.3570",
  "stylex": "static-1.36",
  "HeadJS": "static-2.775",
  "hs-test-utils-bend-plugin": "static-1.3281",
  "msw": "static-1.39",
  "testing-library": "static-1.154",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.224",
  "moment-timezone": "static-5.85",
  "jasmine": "static-4.4473",
  "ai-components-ui-library": "static-1.9315",
  "ai-rendering-library": "static-1.10697",
  "chirp-fetch": "static-1.2036",
  "connections-embed-lib": "static-1.1279",
  "copilot-toolkit": "static-1.11507",
  "feedback-loader": "static-1.29574",
  "laboratory-lib": "static-3.7300",
  "marketplace-embed": "static-1.22520",
  "marketplace-ui-details": "static-1.10139",
  "marketplace-ui-reviews": "static-1.20199",
  "marketplace-ui-tracking": "static-1.14414",
  "sanitize-text": "static-1.8294",
  "ui-addon-video-player": "static-1.8853",
  "usage-tracker-multi": "static-1.5914",
  "usage-tracker-session-replay": "static-1.5186",
  "wootric-nps": "static-1.7093",
  "quartz-head": "static-1.890",
  "web-vitals": "static-1.8",
  "apollo-link-hub-http": "static-2.4799",
  "immer": "static-1.33",
  "immerable": "static-1.4299",
  "highcharts": "static-8.106",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2592",
  "reporting-data": "static-1.68133",
  "cssUtils": "static-1.835",
  "flux-actions": "static-1.350",
  "HubStyle": "static-2.11925",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10356",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10511",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7490",
  "icons": "static-2.659",
  "marketplace-ui-apps-core": "static-1.18776",
  "storybook-react": "static-1.35",
  "trellis-story-utils": "static-1.4657",
  "foundations-components-test-utils": "static-1.5710",
  "quartz-i18n": "static-1.900",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.87",
  "ads-unified-auth-lib": "static-1.568",
  "google-sheets-integration-lib": "static-1.657",
  "microsoft-drive-integration-lib": "static-1.820",
  "surveymonkey-integration-lib": "static-1.106",
  "slack-ui-library": "static-1.10546",
  "fsm": "static-1.3878",
  "customer-data-objects": "static-1.7827",
  "property-translator": "static-1.5544",
  "hs-locale-management": "static-1.192",
  "frontend-preferences-client": "static-1.8075",
  "hs-promise-utils": "static-1.5742",
  "hubspot-apollo-client": "static-1.5026",
  "integrations-error-boundary-lib": "static-1.14024",
  "integrations-tracking-lib": "static-1.5755",
  "native-integrations-shared-strings": "static-1.7928",
  "sanitize": "static-1.4625",
  "superstore": "static-1.4908",
  "ui-shepherd-react": "static-3.10406",
  "ai-settings-ui-library": "static-1.8123",
  "hub-http-janus": "static-1.850",
  "hubspotter-http": "static-1.4761",
  "immutable-less": "static-1.4799",
  "marketplace-ui-client-types": "static-1.17651",
  "nav-meta": "static-1.30009",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18194",
  "inbound-db-properties-service-client": "static-1.3957",
  "property-management-common": "static-1.5939",
  "ui-addon-iframeable": "static-1.9218",
  "dispatcher": "static-1.139",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.549",
  "module-federation": "static-1.28",
  "quartz-auth": "static-1.900",
  "quartz-test": "static-1.900",
  "quartz-tracking": "static-1.604",
  "trellis-components": "static-1.2262",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.218",
  "bender-build-tools": "static-1.3301",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.22017",
  "ContentUtils": "static-1.68788",
  "customer-data-objects-ui-components": "static-1.13178",
  "sassPrefix": "static-1.159",
  "avatar-components": "static-1.2647",
  "breeze-engine-core": "static-1.500",
  "breeze-onboarding-components": "static-1.327",
  "customer-data-filters-ui": "static-1.40320",
  "customer-data-reference-ui-components": "static-1.13324",
  "embedded-academy-lib": "static-1.14825",
  "ExportDialog": "static-6.10527",
  "highlight.js": "static-1.81",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41669",
  "reporting-snowflake": "static-1.56751",
  "reporting-ui-components": "static-2.65404",
  "reporting-visualizations": "static-1.60209",
  "trellis-theming": "static-1.1095",
  "ui-addon-teams": "static-1.21742",
  "integrations-reconnect-lib": "static-1.252",
  "magpie-lib": "static-1.5651",
  "navigation-components": "static-1.18372",
  "breeze-engine-lib": "static-1.1222",
  "magpie-types": "static-1.5111",
  "simple-logging-lib": "static-1.3196",
  "ai-studio-lib": "static-1.12039",
  "app-governance-lib": "static-1.2002",
  "developer-experience-shared-components": "static-1.10682",
  "hubspot-prosemirror": "static-1.18644",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.8160",
  "ui-product-approvals": "static-1.28709",
  "ui-tool-access": "static-1.10299",
  "usage-based-billing-components-lib": "static-1.9546",
  "usage-tracker-anonymous": "static-1.5917",
  "usage-tracker-public": "static-1.7311",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3698",
  "persist-promise": "static-1.3849",
  "reference-resolvers": "static-1.8324",
  "ui-extensibility-client-types": "static-1.4072",
  "hubspot-apollo-cache": "static-1.485",
  "universal-page-editor-lib": "static-1.3160",
  "final-form": "static-1.72",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.3182",
  "atom": "static-1.5223",
  "merchandise-lib": "static-1.266",
  "purchase-motions-components": "static-1.6137",
  "salesImages": "static-1.528",
  "batch-promise": "static-1.1692",
  "crm-component-utils": "static-1.39459",
  "crm-properties-common-lib": "static-1.6038",
  "customer-data-properties": "static-1.52052",
  "framework-data-schema-resolvers": "static-1.7041",
  "property-value-citations": "static-1.2666",
  "reference-resolvers-lite": "static-1.8245",
  "ui-business-units-lib": "static-1.9218",
  "navigation-messaging": "static-1.7699",
  "hubspotter-http-shared-msw-handlers": "static-1.10320",
  "base-ui": "static-1.16",
  "react-day-picker": "static-1.5",
  "tanstack-virtual": "static-1.32",
  "cms-field-types": "static-1.4963",
  "content-icons-ui": "static-1.2271",
  "customer-data-ui-utilities": "static-1.9971",
  "conversations-skeleton-state": "static-1.7396",
  "crm-message-bus": "static-1.43372",
  "customer-data-filters-ui-msw-helpers": "static-1.22755",
  "events-data-lib": "static-1.385",
  "FormUrlGenerator": "static-2.4870",
  "framework-builder-read-service-client": "static-1.4116",
  "framework-data-schema-quick-fetch": "static-1.6946",
  "multi-account-reference-resolvers": "static-1.1129",
  "onboarding-tours": "static-1.16886",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14092",
  "academy-common-lib": "static-1.14285",
  "content-assistance-lib": "static-1.7989",
  "dashboard-lib": "static-1.82096",
  "file-manager-components": "static-1.24054",
  "getting-started-shared-tasks": "static-1.18820",
  "hubspot-prosemirror-plugins": "static-1.18636",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20089",
  "share-with-third-party-component-lib": "static-1.8853",
  "ui-addon-draggable": "static-3.4908",
  "ui-asset-management-lib": "static-1.11229",
  "user-context": "static-1.5258",
  "growth-payments-core": "static-1.25799",
  "reporting-plugins": "static-1.10561",
  "reporting-reports": "static-1.67811",
  "idb-keyval": "static-1.46",
  "reactive-lib": "static-1.873",
  "nest": "static-1.381",
  "ably": "static-2.2",
  "codemirror": "static-5.97",
  "react-codemirror": "static-1.10776",
  "framework-listing-lib": "static-2.29095",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31032",
  "apps-service-types": "static-1.3949",
  "oauth-service-types": "static-1.4402",
  "content-media-capture": "static-1.4973",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8569",
  "payment-link-components": "static-1.23887",
  "ui-addon-emoji-picker": "static-1.10032",
  "video-components-external": "static-1.11759",
  "video-data-lib": "static-1.35417",
  "react-dnd-compat": "static-1.4762",
  "ui-product-approvals-common": "static-1.604",
  "onboarding-scopes": "static-1.6608",
  "onboarding-tours-client": "static-1.5100",
  "platform-infra-nav-components": "static-1.7784",
  "subscription-experience-data-types": "static-1.15102",
  "crm-record-cards-service-types": "static-1.3696",
  "location-customization-utils-lib": "static-1.9669",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.6140",
  "signup-constants": "static-1.19234",
  "signup-ui-url-generator": "static-2.8206",
  "card-properties-lib": "static-1.44625",
  "commerce-subscription-lib": "static-1.37490",
  "crm-actions": "static-1.6487",
  "crm-cards-sdk": "static-1.44021",
  "customer-data-properties-shared-msw-handlers": "static-1.9649",
  "customer-data-tracking": "static-1.7035",
  "hs-resources": "static-1.328",
  "pulse": "static-1.757",
  "calling-global-api": "static-1.64998",
  "calling-internal-common": "static-1.31461",
  "calling-lifecycle-internal": "static-1.66380",
  "calling-lifecycle-messages": "static-1.58674",
  "commerce-products-lib": "static-1.10097",
  "conditional-properties-service-client": "static-1.3908",
  "crm-links": "static-1.6457",
  "crm-pipelines-api-client-types": "static-1.4248",
  "external-options-client-types": "static-1.4237",
  "formula-editor": "static-1.14525",
  "google-libphonenumber": "static-1.40",
  "inbounddb-objects-service-types": "static-1.4328",
  "meetings-icalendar-utils-lib": "static-1.782",
  "multi-currency-client-types": "static-1.3802",
  "object-builder-ui-client": "static-1.49246",
  "pipeline-validation-client-types": "static-1.4077",
  "smart-property-lib": "static-1.8009",
  "tiered-pricing": "static-1.1622",
  "topics-actions-lib": "static-1.254",
  "ui-addon-form-validation": "static-1.11139",
  "zustand": "static-1.74",
  "fdsr-migration-layer": "static-1.160",
  "react-immutable-render-mixin": "static-1.9",
  "restore-request-side-panel-lib": "static-1.1275",
  "growth-data-modal": "static-1.5675",
  "growth-onboarding-confetti": "static-1.3214",
  "growth-onboarding-next-action-utils": "static-1.2321",
  "onboarding-tours-utils": "static-1.952",
  "ui-shepherd-tracker": "static-1.7787",
  "academy-service-client": "static-1.3832",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39553",
  "FileManagerLib": "static-1.39694",
  "SafeStorage": "static-1.4548",
  "video-embed": "static-1.36251",
  "ui-coaching-tips": "static-1.28958",
  "redux-actions": "static-3.7",
  "EmailSignatureEditor": "static-1.24692",
  "viral-links-lib": "static-1.7219",
  "data-token-picker": "static-1.16670",
  "react-flip-move": "static-1.73",
  "nested-table": "static-1.388",
  "timezone-utils": "static-2.5391",
  "seat-types-lib": "static-1.326",
  "getting-started-shared-tasks-store": "static-1.17938",
  "ui-addon-opt": "static-4.8510",
  "campaign-roi-lib": "static-1.9568",
  "ui-addon-calendars": "static-2.5470",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-views-management": "static-1.25749",
  "framework-data-table": "static-2.12248",
  "marketing-platform-lib": "static-1.7014",
  "nudge-client-utils": "static-1.2898",
  "nudge-custom-ui-functions": "static-1.1289",
  "switchboard-lib": "static-1.374",
  "app-users-service-client": "static-1.5761",
  "app-users-service-types": "static-1.5169",
  "mini-checkout-client": "static-1.27170",
  "onboarding-utils": "static-1.5507",
  "permissions-shared-i18n-strings-fe": "static-1.2062",
  "ui-coaching-tips-shared-config": "static-1.28943",
  "content-media-composition-data-lib": "static-1.12777",
  "fix-webm-duration": "static-1.25",
  "notification-sounds": "static-1.4574",
  "commerce-tours-lib": "static-1.6378",
  "growth-onboarding-reliability": "static-1.5229",
  "sales-checkout-service-client": "static-1.3723",
  "content-media-compositions": "static-2.16784",
  "media-bridge-lib": "static-1.19186",
  "edison-service-client-types": "static-1.536",
  "crm_data": "static-4.92417",
  "customer-data-sidebar": "static-2.46410",
  "enrichment-properties-lib": "static-1.17140",
  "ui-addon-draggable-compat": "static-2.4408",
  "universal-record-utils-lib": "static-1.1336",
  "commerce-billing-lib": "static-1.19569",
  "commerce-shared-components-lib": "static-1.18907",
  "commerce-tools-ui-lib": "static-1.10755",
  "crm-fe-perf": "static-1.23049",
  "event-emitter": "static-1.1098",
  "bend-plugin-pulse": "static-1.260",
  "fast-json-patch": "static-1.65",
  "calling-error-reporting": "static-1.31468",
  "shared-worker-versioning": "static-1.11184",
  "calling-usage-tracker": "static-1.6691",
  "voice-sms-access-library": "static-1.1521",
  "commerce-permissions": "static-1.923",
  "products-iframe-lib": "static-1.8328",
  "products-ui-components-shared-msw-handlers": "static-1.10704",
  "bark-lib": "static-1.16613",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.440",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10405",
  "policy-lib": "static-1.6933",
  "react-tinymce": "static-1.55628",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10468",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54754",
  "tinymce-plugins": "static-1.57868",
  "tinymce-themes": "static-1.56724",
  "onboarding-data-sync-lib": "static-1.2226",
  "growth-onboarding-next-action-components": "static-1.2349",
  "user-context-client": "static-1.4718",
  "audio-components": "static-1.6146",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.37205",
  "html-to-image": "static-1.56",
  "urlinator": "static-1.4682",
  "video-components": "static-1.13761",
  "outpost": "static-1.4316",
  "growth-onboarding-feedback-components": "static-1.6727",
  "draft-convert": "static-2.75",
  "draft-extend": "static-3.77",
  "draft-js": "static-5.80",
  "draft-plugins": "static-2.21937",
  "sales-email-signature-service-client": "static-1.3997",
  "ts-utils-lib": "static-1.322",
  "crm-export-dialog": "static-1.6432",
  "crm-index-associations-lib": "static-1.6590",
  "crm-view-components": "static-1.713",
  "react-beautiful-dnd": "static-1.13",
  "customer-data-associations": "static-1.7480",
  "nudge-custom-function-registry": "static-1.2655",
  "nudge-renderer-utils": "static-1.2974",
  "whisper-core-api": "static-1.6944",
  "InboxConnectUtils": "static-4.15205",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5881",
  "settings-content-modals": "static-1.46488",
  "js-cookie": "static-1.18",
  "crm_universal": "static-1.22275",
  "customer-data-email": "static-1.18308",
  "card-payment-highlight-lib": "static-1.37580",
  "card-subscription-highlight-lib": "static-1.39913",
  "commerce-contract-lib": "static-1.12743",
  "invoices-highlight-card-lib": "static-1.55187",
  "orders-highlight-card-lib": "static-1.21862",
  "products-highlight-card-lib": "static-1.18380",
  "quotes-highlight-card-lib": "static-1.72491",
  "crm-source-interpretation-lib": "static-1.5480",
  "crm-object-search-query-utilities": "static-1.9907",
  "utility-belt": "static-1.2680",
  "payments-enrollment-embed-lib": "static-1.23375",
  "stripe-embedded-components": "static-1.7775",
  "customer-data-rte": "static-1.33366",
  "cv-backend-services": "static-1.1583",
  "growth-onboarding-empty-states": "static-1.6023",
  "payments-post-enroll-local-storage-lib": "static-1.5254",
  "qrcode-generator": "static-1.71",
  "quotes-client-types": "static-1.38581",
  "trials-service-types": "static-1.4031",
  "calling-orchestration-schema": "static-1.36298",
  "sales-views-client-types": "static-1.4406",
  "react-reducer-toolkit": "static-1.15991",
  "hub-http-contrib": "static-1.3192",
  "interframe": "static-3.4906",
  "tinymce-data": "static-1.40839",
  "ui-addon-sales-email": "static-1.5359",
  "layout-dnd-components": "static-1.12734",
  "layout-dnd-utils": "static-1.11709",
  "ui-brand-identity-lib": "static-1.15820",
  "NamespacedHubStyle": "static-2.9164",
  "meetings-connect-utils-lib": "static-1.7754",
  "social-insights-client-types": "static-1.22436",
  "crm-index-visualization-core": "static-1.4326",
  "checkout-sdk": "static-3.24013",
  "company-details-components": "static-1.6346",
  "payment-method-components": "static-1.7009",
  "pricing-pages-ui-components": "static-1.14867",
  "quote-checkout-service-types": "static-1.3612",
  "upgrade-catalog-service-types": "static-1.3667",
  "access-control-lib": "static-1.10585",
  "EmailComponents": "static-1.55175",
  "EmailData": "static-1.53852",
  "redux-less": "static-2.9629",
  "sequences-lib": "static-1.8299",
  "ui-gdpr-components": "static-1.10500",
  "products-ui-components": "static-1.40615",
  "accounting-integrations-ui-components": "static-1.7310",
  "invoices-ui-lib": "static-1.55203",
  "commerce-products-api": "static-1.2507",
  "invoices-iframe-lib": "static-1.57261",
  "quotes-modal-lib": "static-1.103169",
  "quotes-ui-lib": "static-1.81212",
  "stripe-connect-js": "static-1.71",
  "draft-content-plugins": "static-1.28631",
  "ContentData": "static-1.68863",
  "layout-data-lib": "static-1.10034",
  "checkout-service-types": "static-1.3907",
  "hub-http-rxjs": "static-1.816",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.4084",
  "billing-payments-client-types": "static-1.4138",
  "react-performance-metrics-lib": "static-1.705",
  "pricing-pages-api": "static-1.14732",
  "ContentComponents": "static-2.71744",
  "marketing-contacts-lib": "static-1.10529",
  "marketing-email-service-types": "static-1.2012",
  "messaging-editing-lib": "static-1.46713",
  "messaging-usage-based-billing-components-lib": "static-1.1575",
  "automation-ui-source-apps": "static-1.19298",
  "automation-ui-types": "static-1.20216",
  "messaging-types-lib": "static-1.46450",
  "onboarding-settings-client": "static-1.4653",
  "sequences-client-types-lib": "static-1.8156",
  "commerce-tax-lib": "static-1.686",
  "price-books-api": "static-1.1328",
  "price-books-components": "static-1.1386",
  "property-description-translator": "static-1.3988",
  "ramp-editor": "static-1.556",
  "commerce-analytics-service-client": "static-1.3711",
  "totals-ui-components": "static-1.23984",
  "SalesContentIndexUI": "static-3.9453",
  "advanced-menus-core": "static-1.15378",
  "advanced-menus-lib": "static-1.12282",
  "ui-memberships-settings-lib": "static-1.34435",
  "segments-query-core": "static-1.1569",
  "automation-ui-ubb": "static-1.6132",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7486",
  "data-token-views": "static-1.16651",
  "forms-utils-lib": "static-1.12862",
  "payments-embed-points-lib": "static-1.13342",
  "simple-menus-core": "static-1.15377",
  "simple-menus-lib": "static-1.16894",
  "videoconference-integration-components": "static-1.7045",
  "mc-hard-limits-client-types": "static-1.46",
  "marketing-contacts-client": "static-1.7658",
  "automation-applications-service-types": "static-1.3607",
  "automation-platform-service-types": "static-1.2632",
  "ContentEditorUI": "static-2.77507",
  "short-messages-app-service-client": "static-1.4070",
  "web-interactives-components": "static-1.14020",
  "web-interactives-data": "static-1.14021",
  "messaging-shared-utils-lib": "static-1.1024",
  "messaging-user-info-utils-lib": "static-1.1194",
  "email-portal-health-service-types": "static-1.1125",
  "line-items-api": "static-1.905",
  "commerce-totals-service-types": "static-1.3927",
  "FireAlarmUi": "static-1.4619",
  "sales-templates-service-types-lib": "static-1.4280",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22152",
  "automation-ui-usage-tracking": "static-1.21615",
  "data-studio-ubb": "static-1.3136",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27353",
  "collaboration-sidebar": "static-1.58282",
  "content-management-data-lib": "static-1.5677",
  "copilot-plugins": "static-1.11480",
  "cta-picker": "static-1.36776",
  "customer-agent-discovery-components-lib": "static-1.3492",
  "editor-components": "static-1.13448",
  "editor-iframe-lib": "static-1.8612",
  "error-messaging-js": "static-1.5343",
  "FormsCommonComponents": "static-1.86205",
  "pictos": "static-7.187",
  "react-transition-group": "static-2.67",
  "redux-request-state": "static-1.10796",
  "SharedLegalStrings": "static-1.1892",
  "smart-content-core": "static-1.42836",
  "smart-content-lib": "static-1.43489",
  "social-composer-lib": "static-1.59679",
  "structured-content-lib": "static-1.25577",
  "theme-previewer-lib": "static-1.53636",
  "tinymce-copilot": "static-1.16822",
  "xray-recommendation-lib": "static-1.8095",
  "automation-ui-routing": "static-1.21573",
  "sql-reporting-client-types": "static-1.5763",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42509",
  "campaigns-utils-lib": "static-1.3344",
  "reporting-enablement": "static-1.23400",
  "chatspot-widget-iframe": "static-1.22008",
  "collaboration-sidebar-common": "static-1.3079",
  "forms-ai-lib": "static-1.4553",
  "codemirror-dlb": "static-1.59066",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6583",
  "report-customization-components": "static-1.13559",
  "data-quality-ui-library": "static-1.13416",
  "reporting-filters": "static-1.682",
  "reporting-insights-lib": "static-1.2165"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12775",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.488",
  "data-fetching-client": "/data-fetching-client/static-1.9808",
  "foundations-components": "/foundations-components/static-1.8227",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1252",
  "foundations-theming": "/foundations-theming/static-1.4585",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.84",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8170",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10322",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11618",
  "I18n": "/I18n/static-7.1643",
  "jasmine-runner": "/jasmine-runner/static-1.6605",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12838",
  "quartz": "/quartz/static-1.7225",
  "react-dlb": "/react-dlb/static-1.82",
  "react-rhumb": "/react-rhumb/static-1.16837",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3004",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10066",
  "reselect": "/reselect/static-3.7",
  "settings-ui-lib": "/settings-ui-lib/static-1.12670",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7408",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11297",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9683",
  "unified-auth": "/unified-auth/static-1.670",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.952",
  "usage-tracker": "/usage-tracker/static-1.7500",
  "usage-tracker-core": "/usage-tracker-core/static-1.7350",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8243",
  "hub-http": "/hub-http/static-1.6369",
  "integrations-lib": "/integrations-lib/static-1.16609",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20244",
  "property-management-iframe": "/property-management-iframe/static-1.13651",
  "quartz-config": "/quartz-config/static-1.1003",
  "quartz-core": "/quartz-core/static-1.6444",
  "quartz-routing": "/quartz-routing/static-1.655",
  "quick-fetch": "/quick-fetch/static-1.4027",
  "react": "/react/static-7.188",
  "rpc-client-utils": "/rpc-client-utils/static-1.4808",
  "ts-schema": "/ts-schema/static-1.4192",
  "ui-universal-auth": "/ui-universal-auth/static-1.9156",
  "UIComponents": "/UIComponents/static-3.8564",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3511",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3502",
  "quartz-webpack": "/quartz-webpack/static-1.3449",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.303",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4496",
  "floating-ui": "/floating-ui/static-1.59",
  "foundations-assets": "/foundations-assets/static-1.5022",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2301",
  "framer-motion": "/framer-motion/static-1.74",
  "hs-story-utils": "/hs-story-utils/static-1.9571",
  "react-aria": "/react-aria/static-1.68",
  "react-create-root-preference": "/react-create-root-preference/static-1.41",
  "react-select-plus": "/react-select-plus/static-1.107",
  "react-utils": "/react-utils/static-2.5451",
  "react-virtualized": "/react-virtualized/static-2.101",
  "StyleGuideUI": "/StyleGuideUI/static-3.490",
  "tanstack-table": "/tanstack-table/static-1.57",
  "trellis-assets": "/trellis-assets/static-1.2243",
  "ui-fonts": "/ui-fonts/static-1.880",
  "ui-images": "/ui-images/static-2.1194",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3068",
  "foundations-theming-base": "/foundations-theming-base/static-1.3570",
  "stylex": "/stylex/static-1.36",
  "HeadJS": "/HeadJS/static-2.775",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3281",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.154",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.224",
  "moment-timezone": "/moment-timezone/static-5.85",
  "jasmine": "/jasmine/static-4.4473",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9315",
  "ai-rendering-library": "/ai-rendering-library/static-1.10697",
  "chirp-fetch": "/chirp-fetch/static-1.2036",
  "connections-embed-lib": "/connections-embed-lib/static-1.1279",
  "copilot-toolkit": "/copilot-toolkit/static-1.11507",
  "feedback-loader": "/feedback-loader/static-1.29574",
  "laboratory-lib": "/laboratory-lib/static-3.7300",
  "marketplace-embed": "/marketplace-embed/static-1.22520",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10139",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20199",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14414",
  "sanitize-text": "/sanitize-text/static-1.8294",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8853",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5914",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5186",
  "wootric-nps": "/wootric-nps/static-1.7093",
  "quartz-head": "/quartz-head/static-1.890",
  "web-vitals": "/web-vitals/static-1.8",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4799",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4299",
  "highcharts": "/highcharts/static-8.106",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2592",
  "reporting-data": "/reporting-data/static-1.68133",
  "cssUtils": "/cssUtils/static-1.835",
  "flux-actions": "/flux-actions/static-1.350",
  "HubStyle": "/HubStyle/static-2.11925",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10356",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10511",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7490",
  "icons": "/icons/static-2.659",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18776",
  "storybook-react": "/storybook-react/static-1.35",
  "trellis-story-utils": "/trellis-story-utils/static-1.4657",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5710",
  "quartz-i18n": "/quartz-i18n/static-1.900",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.87",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.568",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.657",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.820",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.106",
  "slack-ui-library": "/slack-ui-library/static-1.10546",
  "fsm": "/fsm/static-1.3878",
  "customer-data-objects": "/customer-data-objects/static-1.7827",
  "property-translator": "/property-translator/static-1.5544",
  "hs-locale-management": "/hs-locale-management/static-1.192",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8075",
  "hs-promise-utils": "/hs-promise-utils/static-1.5742",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5026",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14024",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5755",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7928",
  "sanitize": "/sanitize/static-1.4625",
  "superstore": "/superstore/static-1.4908",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10406",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8123",
  "hub-http-janus": "/hub-http-janus/static-1.850",
  "hubspotter-http": "/hubspotter-http/static-1.4761",
  "immutable-less": "/immutable-less/static-1.4799",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17651",
  "nav-meta": "/nav-meta/static-1.30009",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18194",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3957",
  "property-management-common": "/property-management-common/static-1.5939",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9218",
  "dispatcher": "/dispatcher/static-1.139",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.549",
  "module-federation": "/module-federation/static-1.28",
  "quartz-auth": "/quartz-auth/static-1.900",
  "quartz-test": "/quartz-test/static-1.900",
  "quartz-tracking": "/quartz-tracking/static-1.604",
  "trellis-components": "/trellis-components/static-1.2262",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.218",
  "bender-build-tools": "/bender-build-tools/static-1.3301",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.22017",
  "ContentUtils": "/ContentUtils/static-1.68788",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13178",
  "sassPrefix": "/sassPrefix/static-1.159",
  "avatar-components": "/avatar-components/static-1.2647",
  "breeze-engine-core": "/breeze-engine-core/static-1.500",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.327",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40320",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13324",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14825",
  "ExportDialog": "/ExportDialog/static-6.10527",
  "highlight.js": "/highlight.js/static-1.81",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41669",
  "reporting-snowflake": "/reporting-snowflake/static-1.56751",
  "reporting-ui-components": "/reporting-ui-components/static-2.65404",
  "reporting-visualizations": "/reporting-visualizations/static-1.60209",
  "trellis-theming": "/trellis-theming/static-1.1095",
  "ui-addon-teams": "/ui-addon-teams/static-1.21742",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.252",
  "magpie-lib": "/magpie-lib/static-1.5651",
  "navigation-components": "/navigation-components/static-1.18372",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1222",
  "magpie-types": "/magpie-types/static-1.5111",
  "simple-logging-lib": "/simple-logging-lib/static-1.3196",
  "ai-studio-lib": "/ai-studio-lib/static-1.12039",
  "app-governance-lib": "/app-governance-lib/static-1.2002",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10682",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18644",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8160",
  "ui-product-approvals": "/ui-product-approvals/static-1.28709",
  "ui-tool-access": "/ui-tool-access/static-1.10299",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9546",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5917",
  "usage-tracker-public": "/usage-tracker-public/static-1.7311",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3698",
  "persist-promise": "/persist-promise/static-1.3849",
  "reference-resolvers": "/reference-resolvers/static-1.8324",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4072",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.485",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3160",
  "final-form": "/final-form/static-1.72",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.3182",
  "atom": "/atom/static-1.5223",
  "merchandise-lib": "/merchandise-lib/static-1.266",
  "purchase-motions-components": "/purchase-motions-components/static-1.6137",
  "salesImages": "/salesImages/static-1.528",
  "batch-promise": "/batch-promise/static-1.1692",
  "crm-component-utils": "/crm-component-utils/static-1.39459",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6038",
  "customer-data-properties": "/customer-data-properties/static-1.52052",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7041",
  "property-value-citations": "/property-value-citations/static-1.2666",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8245",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9218",
  "navigation-messaging": "/navigation-messaging/static-1.7699",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10320",
  "base-ui": "/base-ui/static-1.16",
  "react-day-picker": "/react-day-picker/static-1.5",
  "tanstack-virtual": "/tanstack-virtual/static-1.32",
  "cms-field-types": "/cms-field-types/static-1.4963",
  "content-icons-ui": "/content-icons-ui/static-1.2271",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9971",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7396",
  "crm-message-bus": "/crm-message-bus/static-1.43372",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22755",
  "events-data-lib": "/events-data-lib/static-1.385",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4870",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4116",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6946",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1129",
  "onboarding-tours": "/onboarding-tours/static-1.16886",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14092",
  "academy-common-lib": "/academy-common-lib/static-1.14285",
  "content-assistance-lib": "/content-assistance-lib/static-1.7989",
  "dashboard-lib": "/dashboard-lib/static-1.82096",
  "file-manager-components": "/file-manager-components/static-1.24054",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18820",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18636",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20089",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8853",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4908",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11229",
  "user-context": "/user-context/static-1.5258",
  "growth-payments-core": "/growth-payments-core/static-1.25799",
  "reporting-plugins": "/reporting-plugins/static-1.10561",
  "reporting-reports": "/reporting-reports/static-1.67811",
  "idb-keyval": "/idb-keyval/static-1.46",
  "reactive-lib": "/reactive-lib/static-1.873",
  "nest": "/nest/static-1.381",
  "ably": "/ably/static-2.2",
  "codemirror": "/codemirror/static-5.97",
  "react-codemirror": "/react-codemirror/static-1.10776",
  "framework-listing-lib": "/framework-listing-lib/static-2.29095",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31032",
  "apps-service-types": "/apps-service-types/static-1.3949",
  "oauth-service-types": "/oauth-service-types/static-1.4402",
  "content-media-capture": "/content-media-capture/static-1.4973",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8569",
  "payment-link-components": "/payment-link-components/static-1.23887",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10032",
  "video-components-external": "/video-components-external/static-1.11759",
  "video-data-lib": "/video-data-lib/static-1.35417",
  "react-dnd-compat": "/react-dnd-compat/static-1.4762",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.604",
  "onboarding-scopes": "/onboarding-scopes/static-1.6608",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5100",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7784",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15102",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3696",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9669",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.6140",
  "signup-constants": "/signup-constants/static-1.19234",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8206",
  "card-properties-lib": "/card-properties-lib/static-1.44625",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37490",
  "crm-actions": "/crm-actions/static-1.6487",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44021",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9649",
  "customer-data-tracking": "/customer-data-tracking/static-1.7035",
  "hs-resources": "/hs-resources/static-1.328",
  "pulse": "/pulse/static-1.757",
  "calling-global-api": "/calling-global-api/static-1.64998",
  "calling-internal-common": "/calling-internal-common/static-1.31461",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66380",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58674",
  "commerce-products-lib": "/commerce-products-lib/static-1.10097",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3908",
  "crm-links": "/crm-links/static-1.6457",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4248",
  "external-options-client-types": "/external-options-client-types/static-1.4237",
  "formula-editor": "/formula-editor/static-1.14525",
  "google-libphonenumber": "/google-libphonenumber/static-1.40",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4328",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.782",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3802",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49246",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4077",
  "smart-property-lib": "/smart-property-lib/static-1.8009",
  "tiered-pricing": "/tiered-pricing/static-1.1622",
  "topics-actions-lib": "/topics-actions-lib/static-1.254",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11139",
  "zustand": "/zustand/static-1.74",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.160",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1275",
  "growth-data-modal": "/growth-data-modal/static-1.5675",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3214",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2321",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.952",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7787",
  "academy-service-client": "/academy-service-client/static-1.3832",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39553",
  "FileManagerLib": "/FileManagerLib/static-1.39694",
  "SafeStorage": "/SafeStorage/static-1.4548",
  "video-embed": "/video-embed/static-1.36251",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28958",
  "redux-actions": "/redux-actions/static-3.7",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24692",
  "viral-links-lib": "/viral-links-lib/static-1.7219",
  "data-token-picker": "/data-token-picker/static-1.16670",
  "react-flip-move": "/react-flip-move/static-1.73",
  "nested-table": "/nested-table/static-1.388",
  "timezone-utils": "/timezone-utils/static-2.5391",
  "seat-types-lib": "/seat-types-lib/static-1.326",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17938",
  "ui-addon-opt": "/ui-addon-opt/static-4.8510",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9568",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5470",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-views-management": "/customer-data-views-management/static-1.25749",
  "framework-data-table": "/framework-data-table/static-2.12248",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7014",
  "nudge-client-utils": "/nudge-client-utils/static-1.2898",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1289",
  "switchboard-lib": "/switchboard-lib/static-1.374",
  "app-users-service-client": "/app-users-service-client/static-1.5761",
  "app-users-service-types": "/app-users-service-types/static-1.5169",
  "mini-checkout-client": "/mini-checkout-client/static-1.27170",
  "onboarding-utils": "/onboarding-utils/static-1.5507",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2062",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28943",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12777",
  "fix-webm-duration": "/fix-webm-duration/static-1.25",
  "notification-sounds": "/notification-sounds/static-1.4574",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6378",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5229",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3723",
  "content-media-compositions": "/content-media-compositions/static-2.16784",
  "media-bridge-lib": "/media-bridge-lib/static-1.19186",
  "edison-service-client-types": "/edison-service-client-types/static-1.536",
  "crm_data": "/crm_data/static-4.92417",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46410",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.17140",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4408",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1336",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19569",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18907",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10755",
  "crm-fe-perf": "/crm-fe-perf/static-1.23049",
  "event-emitter": "/event-emitter/static-1.1098",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.260",
  "fast-json-patch": "/fast-json-patch/static-1.65",
  "calling-error-reporting": "/calling-error-reporting/static-1.31468",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11184",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6691",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1521",
  "commerce-permissions": "/commerce-permissions/static-1.923",
  "products-iframe-lib": "/products-iframe-lib/static-1.8328",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10704",
  "bark-lib": "/bark-lib/static-1.16613",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.440",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10405",
  "policy-lib": "/policy-lib/static-1.6933",
  "react-tinymce": "/react-tinymce/static-1.55628",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10468",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54754",
  "tinymce-plugins": "/tinymce-plugins/static-1.57868",
  "tinymce-themes": "/tinymce-themes/static-1.56724",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2226",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2349",
  "user-context-client": "/user-context-client/static-1.4718",
  "audio-components": "/audio-components/static-1.6146",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.37205",
  "html-to-image": "/html-to-image/static-1.56",
  "urlinator": "/urlinator/static-1.4682",
  "video-components": "/video-components/static-1.13761",
  "outpost": "/outpost/static-1.4316",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6727",
  "draft-convert": "/draft-convert/static-2.75",
  "draft-extend": "/draft-extend/static-3.77",
  "draft-js": "/draft-js/static-5.80",
  "draft-plugins": "/draft-plugins/static-2.21937",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3997",
  "ts-utils-lib": "/ts-utils-lib/static-1.322",
  "crm-export-dialog": "/crm-export-dialog/static-1.6432",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6590",
  "crm-view-components": "/crm-view-components/static-1.713",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "customer-data-associations": "/customer-data-associations/static-1.7480",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2655",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2974",
  "whisper-core-api": "/whisper-core-api/static-1.6944",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15205",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5881",
  "settings-content-modals": "/settings-content-modals/static-1.46488",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_universal": "/crm_universal/static-1.22275",
  "customer-data-email": "/customer-data-email/static-1.18308",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37580",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39913",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.12743",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55187",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21862",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18380",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72491",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5480",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.9907",
  "utility-belt": "/utility-belt/static-1.2680",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23375",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7775",
  "customer-data-rte": "/customer-data-rte/static-1.33366",
  "cv-backend-services": "/cv-backend-services/static-1.1583",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6023",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5254",
  "qrcode-generator": "/qrcode-generator/static-1.71",
  "quotes-client-types": "/quotes-client-types/static-1.38581",
  "trials-service-types": "/trials-service-types/static-1.4031",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36298",
  "sales-views-client-types": "/sales-views-client-types/static-1.4406",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.15991",
  "hub-http-contrib": "/hub-http-contrib/static-1.3192",
  "interframe": "/interframe/static-3.4906",
  "tinymce-data": "/tinymce-data/static-1.40839",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5359",
  "layout-dnd-components": "/layout-dnd-components/static-1.12734",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11709",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15820",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9164",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7754",
  "social-insights-client-types": "/social-insights-client-types/static-1.22436",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4326",
  "checkout-sdk": "/checkout-sdk/static-3.24013",
  "company-details-components": "/company-details-components/static-1.6346",
  "payment-method-components": "/payment-method-components/static-1.7009",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.14867",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3612",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3667",
  "access-control-lib": "/access-control-lib/static-1.10585",
  "EmailComponents": "/EmailComponents/static-1.55175",
  "EmailData": "/EmailData/static-1.53852",
  "redux-less": "/redux-less/static-2.9629",
  "sequences-lib": "/sequences-lib/static-1.8299",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10500",
  "products-ui-components": "/products-ui-components/static-1.40615",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7310",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55203",
  "commerce-products-api": "/commerce-products-api/static-1.2507",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57261",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103169",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81212",
  "stripe-connect-js": "/stripe-connect-js/static-1.71",
  "draft-content-plugins": "/draft-content-plugins/static-1.28631",
  "ContentData": "/ContentData/static-1.68863",
  "layout-data-lib": "/layout-data-lib/static-1.10034",
  "checkout-service-types": "/checkout-service-types/static-1.3907",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.816",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.4084",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4138",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.705",
  "pricing-pages-api": "/pricing-pages-api/static-1.14732",
  "ContentComponents": "/ContentComponents/static-2.71744",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10529",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2012",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46713",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1575",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19298",
  "automation-ui-types": "/automation-ui-types/static-1.20216",
  "messaging-types-lib": "/messaging-types-lib/static-1.46450",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4653",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8156",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.686",
  "price-books-api": "/price-books-api/static-1.1328",
  "price-books-components": "/price-books-components/static-1.1386",
  "property-description-translator": "/property-description-translator/static-1.3988",
  "ramp-editor": "/ramp-editor/static-1.556",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3711",
  "totals-ui-components": "/totals-ui-components/static-1.23984",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9453",
  "advanced-menus-core": "/advanced-menus-core/static-1.15378",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12282",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34435",
  "segments-query-core": "/segments-query-core/static-1.1569",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6132",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7486",
  "data-token-views": "/data-token-views/static-1.16651",
  "forms-utils-lib": "/forms-utils-lib/static-1.12862",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13342",
  "simple-menus-core": "/simple-menus-core/static-1.15377",
  "simple-menus-lib": "/simple-menus-lib/static-1.16894",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7045",
  "mc-hard-limits-client-types": "/mc-hard-limits-client-types/static-1.46",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7658",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3607",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2632",
  "ContentEditorUI": "/ContentEditorUI/static-2.77507",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4070",
  "web-interactives-components": "/web-interactives-components/static-1.14020",
  "web-interactives-data": "/web-interactives-data/static-1.14021",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1024",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1194",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1125",
  "line-items-api": "/line-items-api/static-1.905",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3927",
  "FireAlarmUi": "/FireAlarmUi/static-1.4619",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4280",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22152",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21615",
  "data-studio-ubb": "/data-studio-ubb/static-1.3136",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27353",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58282",
  "content-management-data-lib": "/content-management-data-lib/static-1.5677",
  "copilot-plugins": "/copilot-plugins/static-1.11480",
  "cta-picker": "/cta-picker/static-1.36776",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3492",
  "editor-components": "/editor-components/static-1.13448",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8612",
  "error-messaging-js": "/error-messaging-js/static-1.5343",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86205",
  "pictos": "/pictos/static-7.187",
  "react-transition-group": "/react-transition-group/static-2.67",
  "redux-request-state": "/redux-request-state/static-1.10796",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1892",
  "smart-content-core": "/smart-content-core/static-1.42836",
  "smart-content-lib": "/smart-content-lib/static-1.43489",
  "social-composer-lib": "/social-composer-lib/static-1.59679",
  "structured-content-lib": "/structured-content-lib/static-1.25577",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53636",
  "tinymce-copilot": "/tinymce-copilot/static-1.16822",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8095",
  "automation-ui-routing": "/automation-ui-routing/static-1.21573",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5763",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42509",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3344",
  "reporting-enablement": "/reporting-enablement/static-1.23400",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.22008",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3079",
  "forms-ai-lib": "/forms-ai-lib/static-1.4553",
  "codemirror-dlb": "/codemirror-dlb/static-1.59066",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6583",
  "report-customization-components": "/report-customization-components/static-1.13559",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13416",
  "reporting-filters": "/reporting-filters/static-1.682",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2165"
}
};
